import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApiContainer } from "../utils/api";
import {
  LOADING_CHANGE,
  ON_FORM_CHANGE,
  SET_API_DATA,
  SET_ERROR,
} from "../redux/constants";
import { clearFormData, setErrors } from "../shared/CustomFunc";
import { checkValid } from "../shared/validation";

export const LearningAdminContainer = () => {
  const dispatch = useDispatch();
  const { api } = ApiContainer();
  const formPath = { parent: "learningSectionInfo" };
  const [selectedDropdown, setSelectedDropdown] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const learningContentGetData = useSelector(
    (state) => state?.api?.learningContentGetData
  );
  const learningContentListData = useSelector(
    (state) => state?.api?.learningContentListData
  );
  const learningCategoryData = useSelector(
    (state) => state?.api?.learningCategoryData
  );
  const learningSectionInfo = useSelector(
    (state) => state.form.formData?.[formPath.parent]
  );
  const formData = useSelector(
    (state) => state.form.formData?.[formPath.parent]
  );
  const form = useSelector((state) => state?.form);
  const formDataError = useSelector(
    (state) => state.form.formErrors?.[formPath.parent]
  );
  const loader = useSelector((state) => state?.api?.loader?.learningContent);
  const loaderAction = useSelector(
    (state) => state?.api?.loader?.learningActionContent
  );

  // this code for disable previous select option from dropdown
  // const selectedSlotValues = [
  //   formData?.slot_1,
  //   formData?.slot_2,
  //   formData?.slot_3,
  //   formData?.slot_4,
  // ];

  const getLearningContent = async (needLoader = true) => {
    const reportsData = await api({
      method: "GET",
      endPoint: `learning/layout`,
      showToastMessage: false,
      urlencoded: false,
      needLoader,
      parent: "learningContent",
    });
    if (reportsData?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningContentGetData: reportsData?.data,
        },
      });
    }
  };

  const getLearningContentListData = async () => {
    const reportsData = await api({
      method: "GET",
      endPoint: `learning/course-list`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningContent",
    });
    if (reportsData?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningContentListData: reportsData.data,
        },
      });
    }
  };

  const getLearningCategoryData = async () => {
    const reportsData = await api({
      method: "GET",
      endPoint: `learning/categories`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "learningContent",
    });
    if (reportsData?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          learningCategoryData: reportsData.data,
        },
      });
    }
  };

  const postCourseUpdate = async (payload) => {
    const data = await api({
      method: "POST",
      endPoint: "learning/layout",
      data: payload,
      showToastMessage: true,
      parent: "learningActionContent",
      urlencoded: false,
      needLoader: true,
    });
  };

  const onChangeCourse = async (value, rowData, index, keyForState) => {
    setSelectedDropdown((prev) => ({
      ...prev,
      [keyForState]: value,
    }));

    const payload = rowData?.banner_id
      ? {
          banner_id: rowData?.banner_id,
          course_id: value,
          type: "banner",
          position: index,
        }
      : { course_id: value, type: "banner", position: index };

    await postCourseUpdate(payload);
  };

  const handleIconClick = (row) => {
    setSelectedRow(row);
    setOpenModal(true);
  };

  useEffect(() => {
    getLearningContent();
    getLearningContentListData();
    getLearningCategoryData();
  }, []);

  const createEventScheduleAttribute = [
    {
      value: [
        {
          control: "input",
          label: "Section Title",
          type: "text",
          name: "section_title",
          value: "",
          isRequired: true,
          validateAs: "name",
          placeHolder: "Enter section title",
          errorMessage: "Please enter section title",
          fullWidth: true,
          md: 12,
        },
        {
          control: "input",
          label: "Section Description",
          type: "text",
          name: "section_description",
          value: "",
          isRequired: true,
          validateAs: "name",
          placeHolder: "Enter section description",
          errorMessage: "Please enter section description",
          fullWidth: true,
          multiline: true,
          rows: "3",
          md: 12,
        },
      ],
    },
    {
      label: "CHOOSE SECTION CATEGORY",
      value: [
        {
          control: "select",
          label: `Category`,
          name: "category_id",
          value: 0,
          validateAs: "selectMenu",
          isRequired: true,
          fullWidth: true,
          placeHolder: "Select category",
          errorMessage: "Please select any category",
          options: learningCategoryData?.map((item) => ({
            value: item.id,
            key: item.name,
          })),
          md: 12,
          variant: "standard",
        },
      ],
    },
    {
      label: "CHOOSE CONTENT FOR SECTION",
      value: Array.from({ length: 4 }, (_, idx) => {
        const slotName = `slot_${idx + 1}`;

        const selectedCategoryName = learningCategoryData?.find(
          (cat) => cat.id === selectedCategoryId
        )?.id;

        const filteredContent = learningContentListData?.filter(
          (item) => String(item.category_id) === String(selectedCategoryName)
        );

        const dropdownOptions = filteredContent?.flatMap((item) => {
          const options = [];
          options.push({
            value: `${item.id}-null`,
            key: item.name,
            isSubOption: false,
          });

          if (Array.isArray(item?.lessons)) {
            item?.lessons.forEach((lesson) => {
              options.push({
                value: `${lesson.course_id}-${lesson.lessons_id}`,
                key: `${lesson.name}`,
                isSubOption: true,
              });
            });
          }

          return options;
        });

        // this code for disable previous select option from dropdown
        // const dropdownOptions = filteredContent?.flatMap((item) => {
        //   const options = [];

        //   const baseOptionValue = `${item.id}-null`;
        //   options.push({
        //     value: baseOptionValue,
        //     key: item.name,
        //     isSubOption: false,
        //     disabled:
        //       selectedSlotValues.includes(baseOptionValue) &&
        //       formData[`slot_${idx + 1}`] !== baseOptionValue,
        //   });

        //   if (Array.isArray(item.lessons)) {
        //     item.lessons.forEach((lesson) => {
        //       const lessonValue = `${lesson.course_id}-${lesson.lessons_id}`;
        //       options.push({
        //         value: lessonValue,
        //         key: lesson.name,
        //         isSubOption: true,
        //         disabled:
        //           selectedSlotValues.includes(lessonValue) &&
        //           formData[`slot_${idx + 1}`] !== lessonValue,
        //       });
        //     });
        //   }

        //   return options;
        // });

        return {
          control: "select",
          label: `Slot ${idx + 1}`,
          name: slotName,
          value: 0,
          validateAs: "selectMenu",
          isRequired: true,
          fullWidth: true,
          placeHolder: "Select content",
          errorMessage: "Please select any content",
          options: dropdownOptions?.length
            ? dropdownOptions
            : [{ value: "", key: "No data available", disabled: true }],
          md: 6,
          variant: "standard",
        };
      }),
    },
  ];

  useEffect(() => {
    if (selectedRow) {
      const initData = {
        section_title: selectedRow?.section_title || "",
        section_description: selectedRow?.section_description || "",
        section_id: selectedRow?.section_id || null,
        category_id: selectedRow?.category_id || 0,
      };
      setSelectedCategoryId(selectedRow?.category_id || 0);

      selectedRow.courses?.forEach((course, idx) => {
        const slotName = `slot_${idx + 1}`;
        const courseId = course.course_id || 0;
        const lessonId = course.lesson_id || null;
        initData[slotName] = `${courseId}-${lessonId}`;
      });

      dispatch({
        type: ON_FORM_CHANGE,
        payload: {
          formData: {
            ...form.formData,
            [formPath.parent]: {
              ...form.formData?.[formPath.parent],
              ...initData,
            },
          },
          formErrors: {
            ...form.formErrors,
            [formPath.parent]: {},
          },
        },
      });
    }
  }, [selectedRow]);

  const setFormData = (name, value) => {
    if (name === "category_id") {
      setSelectedCategoryId(value);
      const clearedSlots = {
        slot_1: "",
        slot_2: "",
        slot_3: "",
        slot_4: "",
      };

      const clearedErrors = {
        category_id: false,
        ...Object?.fromEntries(
          Object?.keys(clearedSlots)?.map((slot) => [slot, false])
        ),
      };

      dispatch({
        type: ON_FORM_CHANGE,
        payload: {
          formData: {
            ...form.formData,
            [formPath.parent]: {
              ...formData,
              category_id: value,
              ...clearedSlots,
            },
          },
          formErrors: {
            ...form.formErrors,
            [formPath.parent]: {
              ...form.formErrors?.[formPath.parent],
              ...clearedErrors,
            },
          },
        },
      });

      return;
    }

    dispatch(setErrors({ errors: formDataError, value, name, formPath }));

    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...form.formData,
          [formPath.parent]: { ...formData, [name]: value },
        },
      },
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(name, value);
  };

  const extractIds = (val) => {
    if (!val) return [null, null];
    const [courseId, lessonId] = val
      ?.split("-")
      ?.map((v) => (v === "null" ? null : Number(v)));
    return [courseId, lessonId];
  };

  const apiCall = async () => {
    const payload = {
      type: "section",
      section_id: learningSectionInfo?.section_id,
      title: learningSectionInfo.section_title,
      category_id: learningSectionInfo?.category_id,
      description: learningSectionInfo.section_description,
      course_ids: [
        extractIds(learningSectionInfo.slot_1),
        extractIds(learningSectionInfo.slot_2),
        extractIds(learningSectionInfo.slot_3),
        extractIds(learningSectionInfo.slot_4),
      ],
    };

    const data = await api({
      method: "POST",
      endPoint: "learning/layout",
      data: payload,
      showToastMessage: true,
      parent: "learningActionContent",
      urlencoded: false,
      needLoader: true,
    });

    if (data?.data?.success) {
      setOpenModal(false);
      dispatch(clearFormData(formPath.parent));
      getLearningContent(false);
      dispatch({ type: LOADING_CHANGE, payload: { refeatchLayout: true } });
    }
  };

  const handleCreateEventSchedule = (e) => {
    e.preventDefault();
    let errors = {};

    createEventScheduleAttribute?.forEach((item) => {
      Object.values(item.value)?.forEach((control) => {
        const { name, validateAs, label } = control;
        errors = {
          ...errors,
          [name]: validateAs
            ? checkValid({
                validateAs,
                name,
                value: learningSectionInfo?.[name],
                label,
              })
            : false,
        };
      });
    });

    dispatch({
      type: SET_ERROR,
      payload: {
        formErrors: {
          ...form.formErrors,
          [formPath.parent]: { ...errors },
        },
      },
    });

    const hasErrors = Object.values(errors).some((err) => err);
    if (!hasErrors) {
      apiCall();
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    dispatch(setErrors({ errors: {}, name, formPath }));
  };

  useEffect(() => {
    if (openModal) {
      return () => {
        setSelectedRow({});
        dispatch({
          type: ON_FORM_CHANGE,
          payload: {
            formData: {
              ...form.formData,
              [formPath.parent]: {},
            },
          },
        });
      };
    }

    return undefined;
  }, [openModal]);

  return {
    loader,
    learningContentGetData,
    learningContentListData,
    postCourseUpdate,
    handleChange,
    handleCreateEventSchedule,
    createEventScheduleAttribute,
    selectedRow,
    openModal,
    setOpenModal,
    selectedDropdown,
    onChangeCourse,
    handleIconClick,
    handleClose,
    loaderAction,
    setSelectedRow,
  };
};
